import AuthProvider from "@/components/Provider/AuthProvider";
import { VStack } from "goi_common";
import ParlorMatchRequestSection from "./components/MatchRequest/ParlorMatchRequestSection";

export default function MatchParlorMatchRequestContainer() {
  return (
    <AuthProvider redirectToIfNotLoggedIn="/match/request/">
      <VStack alignItems="center">
        <VStack id="wrapper" width="100%" maxWidth="480px">
          <ParlorMatchRequestSection />
        </VStack>
      </VStack>
    </AuthProvider>
  );
}
